
import { Link } from 'react-router-dom';

export default function StrategySection() {
  const strategies = [
    {
      icon: 'ri-compass-discover-line',
      title: '制作を迷っている方へ',
      description: '「本当に必要なのか」「どこに頼めばいいのか」迷うのは当然です。まずはお話を聞かせてください。'
    },
    {
      icon: 'ri-route-line',
      title: 'まずは方向性の整理だけでも可能です',
      description: '制作の前に、目的・ターゲット・導線を一緒に整理します。それだけでも価値があります。'
    },
    {
      icon: 'ri-lightbulb-line',
      title: '売れる設計についてお話しします',
      description: '見た目ではなく、問い合わせにつながる構造とは何か。具体的にご説明します。'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-accent-light to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-navy mb-4">
            私たちの戦略
          </h2>
          <p className="text-xl text-gray-600">
            成果につながる制作のために
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {strategies.map((item, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100"
            >
              <div className="w-14 h-14 bg-accent rounded-lg flex items-center justify-center mb-6">
                <i className={`${item.icon} text-2xl text-navy-light`}></i>
              </div>
              <h3 className="text-xl font-bold text-navy mb-4">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-cta hover:bg-cta/90 text-white px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-chat-1-line"></i>
            現状診断も可能です
          </Link>
        </div>
      </div>
    </section>
  );
}
